module.exports = __webpack_public_path__ + "static/cp-feature-3-63ead3bae33bcfc9791b328bcedd1350.png";